import { render, staticRenderFns } from "./DaTaoKeGoodsDetail.vue?vue&type=template&id=2a3adebf&scoped=true&"
import script from "./DaTaoKeGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./DaTaoKeGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DaTaoKeGoodsDetail.vue?vue&type=style&index=0&id=2a3adebf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3adebf",
  null
  
)

export default component.exports